import React from 'react';
import { CopyableBlock } from '../CopyableBlock';

const VideoVariant = ({ label, variant, idPrefix }) => {
  if (!variant) return null;
  return (
    <div className="mb-5 pb-5 border-b border-gray-100 last:border-0">
      <h4 className="text-sm font-bold text-gray-900 mb-3">{label}</h4>
      <CopyableBlock label="Visual suggestions" content={variant.visual_suggestions} testId={`${idPrefix}-vis`} />
      <CopyableBlock label="On-screen text" content={variant.on_screen_text} testId={`${idPrefix}-osd`} />
      <CopyableBlock label="Voice-over copy" content={variant.voice_over} testId={`${idPrefix}-vo`} />
    </div>
  );
};

export const VideoOutputs = ({ data }) => {
  if (!data) return null;
  return (
    <div data-testid="output-video">
      <VideoVariant label="15-second reel" variant={data.fifteen_second} idPrefix="v15" />
      <VideoVariant label="30-second reel" variant={data.thirty_second} idPrefix="v30" />
      <VideoVariant label="60-second reel" variant={data.sixty_second} idPrefix="v60" />
    </div>
  );
};

export default VideoOutputs;
